import { render, staticRenderFns } from "./fish.vue?vue&type=template&id=38221c06&scoped=true&"
import script from "./fish.vue?vue&type=script&lang=js&"
export * from "./fish.vue?vue&type=script&lang=js&"
import style0 from "./fish.vue?vue&type=style&index=0&id=38221c06&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38221c06",
  null
  
)

export default component.exports